// extracted by extract-css-chunks-webpack-plugin
module.exports = {"continueButton":"add-to-cart-modal__continueButton__BsbIF","commitText":"add-to-cart-modal__commitText__pFdyY"};